import { NoMatchPage } from '@modules/app'

export default NoMatchPage
